import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { ApiService } from '../../../../services/api.service';

@Component({
    selector: 'pci-footer',
    standalone: true,
    imports: [CommonModule, RouterLink],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
    adtrax: string = '';
    links = [
        { path: '/', label: 'Home' },
        { path: '/solutions', label: 'Solutions' },
        { path: '/news', label: 'News' },
        { path: '/publications', label: 'Publications' }
    ];
    cacheBuster = Date.now();

    constructor(private api: ApiService) {}

    ngOnInit(): void {
        this.api.getAdtrax().subscribe(res => (this.adtrax = res.result));
    }
}
